export const ResultsPageQuestions = {
  tabsKey: 'affordabilityCalculator.results.tabs.',
  newCalculationsKey: 'affordabilityCalculator.results.createNewCalculation',
  footnoteKeys: {
    p1: 'affordabilityCalculator.results.footnote.p1',
    p2: 'affordabilityCalculator.results.footnote.p2',
    p3: 'affordabilityCalculator.results.footnote.p3',
  },
};
